export enum SIM_STATUS {
	ACTIVE = 'ACTIVE',
	INACTIVE = 'INACTIVE',
	PROCESSING = 'PROCESSING',
	NOT_AVAILABLE = 'NOT_AVAILABLE',
	NOT_SUPPORTED = 'NOT_SUPPORTED',
	DATA_LIMIT_REACHED = 'DATA_LIMIT_REACHED',
}

export enum ICON_TYPE {
	DEVICE = 1,
	POINT_OF_INTEREST = 2,
}
export const SIM_STATUS_TAG_COLOR: Record<SIM_STATUS, string> = {
	ACTIVE: 'success',
	NOT_AVAILABLE: 'error',
	INACTIVE: 'default',
	PROCESSING: 'processing',
	NOT_SUPPORTED: 'warning',
	DATA_LIMIT_REACHED: 'warning',
};

export type StatusDescription = {
	status: SIM_STATUS;
	color: string;
	description: string;
};

export const SIM_STATUS_DESCRIPTION: Record<SIM_STATUS, StatusDescription> = {
	ACTIVE: {
		status: SIM_STATUS.ACTIVE,
		color: 'success',
		description:
			'The SIM card is fully operational and successfully connected to the carrier’s network,functioning as intended.',
	},
	INACTIVE: {
		status: SIM_STATUS.INACTIVE,
		color: 'default',
		description: 'The SIM card is currently deactivated and unable to connect to the carrier’s network.',
	},
	PROCESSING: {
		status: SIM_STATUS.PROCESSING,
		color: 'processing',
		description:
			'The SIM card is in a transitional state due to an ongoing operation, such as activation, deactivation, or a carrier-related update. It is temporarily unable to function until the process is completed.',
	},
	DATA_LIMIT_REACHED: {
		status: SIM_STATUS.DATA_LIMIT_REACHED,
		color: 'warning',
		description:
			'Indicates the user has reached their monthly data limit, with access automatically resetting at the next billing cycle',
	},
	NOT_AVAILABLE: {
		status: SIM_STATUS.NOT_AVAILABLE,
		color: 'error',
		description:
			'The status of the SIM card could not be retrieved from the carrier, making it temporarily unavailable.',
	},
	NOT_SUPPORTED: {
		status: SIM_STATUS.NOT_SUPPORTED,
		color: 'warning',
		description:
			'The carrier does not provide a way to retrieve the status of this SIM card, making it impossible to determine its state.',
	},
};

export enum SIM_ACTIONS {
	ACTIVATE = 'Activate',
	DEACTIVATE = 'Deactivate',
	CHANGE_PLAN = 'ChangePlan',
}
